import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import OrientationModal from "./Component/OrientationModal";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
	
	// <BrowserRouter>
	<HashRouter>
		<OrientationModal>
			<StrictMode>
				<App />
			</StrictMode>
		</OrientationModal>
	</HashRouter>
	// </BrowserRouter>
);
